module.exports = __webpack_public_path__ + "img/amongImg.5859b2cf.jpg";